/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniPathParams,
  PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniQueryParams,
  PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini400,
  PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini401,
  PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini500,
} from "../../types/individualPaymentVanzoliniController/PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini } from "../../clients/individualPaymentVanzoliniController/postApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini.ts";

export const postApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniMutationKey =
  () =>
    [
      {
        url: "/api/v1/individualpayment/parcels/:parcelId/take-advantage-vanzolini",
      },
    ] as const;

export type PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniMutationKey =
  ReturnType<
    typeof postApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniMutationKey
  >;

export function postApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    postApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniMutationKey();
  return mutationOptions<
    PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini400
      | PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini401
      | PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniPathParams["parcelId"];
      params?: PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniQueryParams;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ parcelId, params }) => {
      return postApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini(
        parcelId,
        params,
        config,
      );
    },
  });
}

/**
 * @description Transfere o serial do boleto excedente para a parcela alvo, baixa a parcela, integra a parcela de origem e antecipa a emissão da NF. Migrado do legado IndividualPayment/TakeAdvantageInstallmentVanzolini. **(Requer Authorization para autenticação)**
 * @summary Aproveita um boleto excedente na parcela em aberto (Vanzolini) (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/take-advantage-vanzolini}
 */
export function usePostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini400
        | PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini401
        | PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini500
      >,
      {
        parcelId: PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniPathParams["parcelId"];
        params?: PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniQueryParams;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniMutationKey();

  const baseOptions =
    postApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini400
        | PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini401
        | PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini500
      >,
      {
        parcelId: PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniPathParams["parcelId"];
        params?: PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniQueryParams;
      },
      TContext
    >;

  return useMutation<
    PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini400
      | PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini401
      | PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniPathParams["parcelId"];
      params?: PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniQueryParams;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini400
      | PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini401
      | PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniPathParams["parcelId"];
      params?: PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniQueryParams;
    },
    TContext
  >;
}
